import type { LocationAddButtonProps } from "./location-add-button.type";

import { useTranslation } from "react-i18next";

import { useGetCurrentUserOrganization } from "@/entities/current-user";
import LocationCreate from "@/modules/location/location-create";
import ModelAddButton from "@/modules/model-add-button";

const LocationAddButton = ({
  parentOrganization,
  parentLocation,
  ...options
}: LocationAddButtonProps) => {
  const { t } = useTranslation();
  const { organization: userOrganization } = useGetCurrentUserOrganization();

  const isCreatingSector = !!parentLocation;
  const title = isCreatingSector
    ? t("sector:add.label")
    : t("location:add.label");

  return (
    <ModelAddButton
      model="location"
      sidePanelTitle={title}
      buttonTitle={title}
      component={
        <LocationCreate
          parentOrganization={parentOrganization ?? userOrganization}
          parentLocation={parentLocation}
        />
      }
      {...options}
    />
  );
};

export default LocationAddButton;
